import type { ReactElement } from 'react';
import React from 'react';
import { Label as ReactstrapLabel } from 'reactstrap';

type Props = {
  htmlFor: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
};

export default function Label({ htmlFor, required, className, children }: Props): ReactElement {
  return (
    <ReactstrapLabel for={htmlFor} className={className}>
      {children}
      {required && (
        <>
          <span className="required-asterisk">*</span>
          <span className="visually-hidden"> &nbsp; (required)</span>
        </>
      )}
    </ReactstrapLabel>
  );
}
